import { render, staticRenderFns } from "./CatalogTable.vue?vue&type=template&id=bb41a0c2&"
import script from "./CatalogTable.vue?vue&type=script&lang=js&"
export * from "./CatalogTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports